var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapper,{tag:"component",attrs:{"canPost":_vm.canPost,"isFetching":_vm.isFetching,"posts":_vm.posts},on:{"form-open":function($event){return _vm.showPostForm()},"post-delete":_vm.onPostDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }